module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-camera-water-resistance.8009d118.mp4";